import { BeSlider, BeStack } from "@beos-css/react/index.ts";
import { useState } from "react";

export function SliderDemo() {
	const [volume, setVolume] = useState(60);
	const [cache, setCache] = useState(1024);
	const [freq, setFreq] = useState(60);

	return (
		<section id="demo-slider">
			<h2>Slider (BSlider)</h2>
			<p>
				One control, two thumb styles, verified against live R5 captures. Drag or arrow-key; the thumb darkens while pressed (a
				non-authentic affordance). Sliders auto-expand to fill their container.
			</p>

			<h3>Block thumb (B_BLOCK_THUMB)</h3>
			<p>A dark recessed groove + a raised block thumb with three grip dots.</p>
			<BeStack gap="label" className="demo-narrow">
				<BeSlider value={volume} onChange={setVolume} label="Volume" />
				<span>Value: {volume}</span>
			</BeStack>

			<h3>Triangle thumb (Fonts &gt; Cache)</h3>
			<p>
				An exact recreation of the Fonts preflet's Cache slider: B_TRIANGLE_THUMB + UseFillColor blue + limit labels, with the value as
				trailing text.
			</p>
			<BeStack gap="label" className="demo-narrow">
				<BeSlider
					thumbStyle="triangle"
					value={cache}
					onChange={setCache}
					min={64}
					max={4096}
					step={16}
					fillColor="rgb(102, 152, 203)"
					label="Screen font cache size"
					showLabel
					trailing={`${cache} kB`}
					minLabel="64 kB"
					maxLabel="4096 kB"
				/>
			</BeStack>

			<h3>Hash marks (ticks)</h3>
			<p>
				Beveled 2px ticks outside the bar (SetHashMarks / SetHashMarkCount), on either style — here 11 ticks, both sides on the triangle,
				below on the block.
			</p>
			<BeStack gap="label" className="demo-narrow">
				<BeSlider
					thumbStyle="triangle"
					value={freq}
					onChange={setFreq}
					ticks={11}
					hashMarks="both"
					fillColor="rgb(102, 152, 203)"
					label="Frequency"
				/>
				<BeSlider value={freq} onChange={setFreq} ticks={11} label="Frequency (block)" />
			</BeStack>

			<h3>Disabled</h3>
			<p>
				R5 lightens every colour toward white with <code>shift_color(c, 0.5)</code>, then floors it to the 8-step grey ramp — BSlider is the
				one control that draws through a <code>B_CMAP8</code> offscreen. So <code>disabled(c) = floor8(int(255 - (255 - c) * 0.5))</code>:
				black&nbsp;→&nbsp;120, the block groove 80&nbsp;→&nbsp;160, the triangle bar 184&nbsp;→&nbsp;216. The fill is not tinted at all — R5
				simply doesn't draw it. The control is also inert to pointer and keyboard (<code>aria-disabled</code>, <code>tabindex=-1</code>),
				not merely dimmed.
			</p>
			<BeStack gap="label" className="demo-narrow">
				<BeSlider value={volume} onChange={setVolume} label="Volume (disabled)" disabled />
				<BeSlider thumbStyle="triangle" value={freq} onChange={setFreq} ticks={11} label="Frequency (disabled)" disabled />
				<BeSlider value={volume} onChange={setVolume} fillColor="rgb(102, 152, 203)" label="Block + fill (disabled)" disabled />
				<BeSlider
					thumbStyle="triangle"
					value={freq}
					onChange={setFreq}
					fillColor="rgb(102, 152, 203)"
					minLabel="min"
					maxLabel="max"
					label="Triangle + fill (disabled)"
					disabled
				/>
			</BeStack>
		</section>
	);
}
